import { useEffect } from "react";
import { connect } from "react-redux";
import { Actions as MYACTIONS } from "../../store/actions/myActions";
import { Actions as SIDEBARACTIONS } from "../../store/actions/sidebarActions";
import PaymentModal from "../billing/PaymentModal";

import { EllipsisVerticalIcon } from "@heroicons/react/20/solid";
import { ClipboardIcon } from "@/icons/outline";
import { Actions as AUTHENITCATIONACTIONS } from "../../store/actions/authenticationActions";
import { Actions as COMPANYACTIONS } from "../../store/actions/companyActions";
import NotificationButton from "../notifications/NotificationButton";
import NavbarNavButtons from "./NavbarNavButtons";
import CompanyModal from "./company-list/CompanyModal";
import OptionsBtn from "./options/OptionsBtn";

const Navbar = ({
	currentOrg,
	toggleSidebar,
	setNewCompanyModal,
	isAdmin,
	getOrganisations,
	demoState,
	accountStatus,
}) => {
	useEffect(() => {
		if (window.innerWidth <= 992) toggleSidebar();
		getOrganisations();
	}, []);

	// useEffect(() => {
	// 	if (window.location.pathname.includes("/team/")) {
	// 		const urlParams = new URLSearchParams(window.location.search);
	// 		const teamID = urlParams.get("teamID");

	// 		if (currentDepartment && teamID && currentDepartment != teamID) {
	// 			updateCurrentDepartment(teamID);
	// 		}
	// 	}
	// }, [currentDepartment]);

	// const managerModeStyle = {
	// 	background: "black",
	// 	color: "white",
	// 	transition: "background 0.2s ease-in-out",
	// };

	// const headerStyle = mode == "manager" ? managerModeStyle : { transition: "background 0.2s ease-in-out" };

	return (
		<>
			<PaymentModal />
			<header
				id="header-navbar"
				className="content-mini content-mini-full"
				style={{
					// ...headerStyle,
					zIndex: "10",
				}}
			>
				<ol className="nav-header pull-right">
					<li>
						<div className="btn-group">
							<NotificationButton />
						</div>
					</li>

					<li>
						<OptionsBtn />
					</li>
				</ol>
				<div className="pull-right">
					{demoState ? (
						<div
							className={`btn btn-success`}
							style={{ marginRight: 10 }}
							onClick={() => setNewCompanyModal()}
						>
							Setup Live Company
						</div>
					) : null}
					{/* <VideoPlayback /> */}
					{/* <VideoModal /> */}
					{/* <PaymentNeeded /> */}
				</div>
				<ol className="nav-header pull-left">
					<li className="hidden-md hidden-lg">
						<button
							className="btn btn-default"
							onClick={() => toggleSidebar()}
							type="button"
							style={{ padding: 5, paddingBottom: 1 }}
						>
							<EllipsisVerticalIcon style={{ height: "1.5em" }} />
						</button>
					</li>
					<li className="hidden-xs hidden-sm">
						<button
							className="btn btn-default"
							onClick={() => toggleSidebar()}
							type="button"
							style={{ padding: 5, paddingBottom: 1 }}
						>
							<EllipsisVerticalIcon style={{ height: "1.5em" }} />
						</button>
					</li>
					<li>
						<NavbarNavButtons />
					</li>
				</ol>
			</header>
		</>
	);
};

const mapStateToProps = (state) => {
	const hasDemo = state.organisations?.find((organisation) => organisation.isDemo);
	const demoState = Array.isArray(state.organisations) && !(state.organisations || [])?.find((item) => !item.isDemo) && hasDemo;

	const { profile } = state.my;

	return {
		mode: state.mode,
		currentOrg: state.company?.settings?.org,
		isAdvisor: profile.isAdvisor,
		advisorName: profile.advisorName,
		isAdmin: profile.isAdmin,
		demoState,
		accountStatus: state?.company?.settings?.status,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getOrganisations: () => dispatch(AUTHENITCATIONACTIONS.getOrganisations()),
	myUpdateCurrentAgreement: (agreement) => dispatch(MYACTIONS.myUpdateCurrentAgreement(agreement)),
	toggleSidebar: () => dispatch(SIDEBARACTIONS.toggleSidebar()),
	setNewCompanyModal: () => dispatch(COMPANYACTIONS.setNewCompanyModal(true)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
